module.exports = __webpack_public_path__ + "static/img/renz1.dfeacc8f.webp";